import React from 'react';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  mono?: boolean;
  hint?: string;
}

export function Input({
  label,
  placeholder,
  value,
  onChange,
  type = 'text',
  error,
  mono = false,
  disabled = false,
  hint,
  style,
  ...props
}: InputProps) {
  return (
    <label style={{ display: 'flex', flexDirection: 'column', gap: 6, fontFamily: 'var(--font-body)', width: '100%', ...style }}>
      {label && (
        <span style={{ fontSize: 'var(--text-xs)', color: 'var(--text-secondary)', fontWeight: 'var(--fw-medium)' }}>
          {label}
        </span>
      )}
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        style={{
          background: 'var(--bg-inset)',
          color: 'var(--text-primary)',
          border: `1px solid ${error ? 'var(--danger)' : 'var(--border-default)'}`,
          borderRadius: 'var(--radius-md)',
          padding: '9px 12px',
          fontSize: 'var(--text-sm)',
          fontFamily: mono ? 'var(--font-mono)' : 'var(--font-body)',
          outline: 'none',
          opacity: disabled ? 0.5 : 1,
          boxSizing: 'border-box',
          width: '100%',
          transition: 'border-color var(--duration-fast), box-shadow var(--duration-fast)',
        }}
        onFocus={(e) => {
          e.target.style.boxShadow = 'var(--focus-ring)';
          e.target.style.borderColor = 'var(--accent)';
        }}
        onBlur={(e) => {
          e.target.style.boxShadow = 'none';
          e.target.style.borderColor = error ? 'var(--danger)' : 'var(--border-default)';
        }}
        {...props}
      />
      {hint && !error && (
        <span style={{ fontSize: 'var(--text-xs)', color: 'var(--text-tertiary)' }}>{hint}</span>
      )}
      {error && <span style={{ fontSize: 'var(--text-xs)', color: 'var(--danger)' }}>{error}</span>}
    </label>
  );
}
